import classNames from "classnames"
import React, { useEffect, useRef, useState } from "react"

import { useTranslation } from "../../i18n/translate"
import { EffectProductFilterModel } from "../../model/product-filter/effect-product-filter-model"
import Effect from "../effect/effect"
import FpTooltip from "../tooltip/tooltip"
import "./product-param.sass"

const ProductParam = ({ type, param, group, paramRef, vertical = false }) => {
  const { t } = useTranslation()
  const singleParamRef = useRef()
  const [isTooWide, setTooWide] = useState(false)

  useEffect(() => {
    if (singleParamRef?.current?.clientWidth > 500) {
      setTooWide(true)
    }
  }, [param, group, singleParamRef])

  return (
    <div ref={paramRef}>
      {(() => {
        let val
        switch (type) {
          case "ENUM":
            if (!vertical) {
              val = param
                .sort((a, b) => t(a.value.key).localeCompare(t(b.value.key)))
                .reduce((acc, curr) => acc + ", " + t(curr.value.key), "")
                .replace(/^,\s/, "")
              return (
                <FpTooltip
                  showArrow={false}
                  position={"top-start"}
                  html={
                    <ul>
                      {param.map((v, i) => {
                        return <li key={i + v.value.key}>• {t(v.value.key)}</li>
                      })}
                    </ul>
                  }
                  disabled={!isTooWide}
                >
                  <p
                    style={{ width: isTooWide ? "500px" : "" }}
                    ref={singleParamRef}
                    className={"_fp-text _fp-enum-text"}
                  >
                    {val || "-"}
                  </p>
                </FpTooltip>
              )
            }
            return (
              <ul>
                {param.map((v, index) => {
                  return <li key={index}>{t(v.value.key)}</li>
                })}
              </ul>
            )
          case "EFFECT":
            val = param
              .sort(EffectProductFilterModel.Comparator)
              .map((val, index) => (
                <Effect
                  key={`effect-${index}`}
                  effectBackgroundColor={val.color}
                  effectTooltip={t(val.label.key)}
                  effectLabel={val.value}
                />
              ))
            if (val.length > 0) {
              return (
                <div
                  className={classNames(
                    "_fp-product-comparison__products__column__row__effect-parameter",
                    {
                      "_fp-product-comparison__products__column__row__effect-parameter--wrap":
                        vertical,
                    },
                  )}
                >
                  {val}
                </div>
              )
            } else {
              return (
                <p
                  className={classNames(
                    "_fp-text _fp-product-comparison__products__column__row__effect-parameter",
                    {
                      "_fp-product-comparison__products__column__row__effect-parameter--wrap":
                        vertical,
                    },
                  )}
                >
                  <span>-</span>
                </p>
              )
            }

          case "NUMBER":
            if (param[0]) {
              return (
                <p className={"_fp-text"}>
                  {group.prefix}
                  {param[0].value}
                  {group.suffix}
                </p>
              )
            } else {
              return <p className={"_fp-text"}>-</p>
            }
          case "RANGE":
            const value = param[0]
            if (!value || (!value.lastValue && !value.firstValue)) {
              return <p className={"_fp-text"}>-</p>
            }

            if (
              (group.abs_min !== null &&
                group.abs_max !== null &&
                value.lastValue >= group.abs_max &&
                value.firstValue < group.abs_max) ||
              value.lastValue === null
            ) {
              return (
                <p className={"_fp-text"}>
                  &gt; {group.prefix}
                  {value.firstValue}
                  {group.suffix}
                </p>
              )
            }

            if (
              (group.abs_min !== null &&
                group.abs_max !== null &&
                value.firstValue <= group.abs_min &&
                value.lastValue > group.abs_min) ||
              value.firstValue === null
            ) {
              return (
                <p className={"_fp-text"}>
                  &lt; {group.prefix}
                  {value.lastValue}
                  {group.suffix}
                </p>
              )
            }

            if (value.firstValue === value.lastValue) {
              return (
                <p className={"_fp-text"}>
                  {group.prefix}
                  {value.firstValue}
                  {group.suffix}
                </p>
              )
            }
            return (
              <p className={"_fp-text"}>
                {group.prefix}
                {value.firstValue}
                {group.suffix} - {group.prefix}
                {value.lastValue}
                {group.suffix}
              </p>
            )
          case "DUAL_NUMBER":
            if (param[0]) {
              return (
                <p className={"_fp-text"}>
                  <span style={{ whiteSpace: "nowrap" }}>
                    <span className={"_fp-dual-number-inline-label"}>
                      {group.label1}
                    </span>
                    {group.prefix}
                    {param[0].value1}
                    {group.suffix}
                  </span>
                  <span style={{ marginLeft: "1rem", whiteSpace: "nowrap" }}>
                    <span className={"_fp-dual-number-inline-label"}>
                      {group.label2}
                    </span>
                    {group.prefix}
                    {param[0].value2}
                    {group.suffix}
                  </span>
                </p>
              )
            } else {
              return <p className={"_fp-text"}>-</p>
            }
          default:
            return <p className={"_fp-text"}>-</p>
        }
      })()}
    </div>
  )
}

export default ProductParam
